const tabs = document.querySelectorAll('.contact-page__form [data-bs-toggle="pill"]');
// const tabContents = document.querySelectorAll('.contact-page__form [role="tabpanel"]');
const contentColumn = document.querySelector('.rectangle-bg-image__image');

tabs.forEach(tab => {
  tab.addEventListener('shown.bs.tab', (e) => {
    if (e.target.id === 'tab-business-property-form') {
      contentColumn.classList.add('bg-peach');
      contentColumn.classList.remove('bg-blue');
    } else if (e.target.id === 'tab-my-m-property-form') {
      contentColumn.classList.add('bg-blue');
      contentColumn.classList.remove('bg-peach');
    }
  });
});